var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionEdit',{attrs:{"disabled":_vm.disabled,"btn-classes":"btn-primary","btn-classes-mobile":"text-primary","to":_vm.modifiedTo}})}
var staticRenderFns = []

export { render, staticRenderFns }